export class AppSettings {
    static apiEndPoint: string;
    static isDebugging: boolean;
    static envName: string;
    static smallDeviceWidth: number;
}
